$(function () {

  $('[name="purchaseTypeToggle"]').click(function () {
    calculatePrice();
  });

})

function calculatePrice() {
    // Sin componente de suscripción en la página no hay nada que calcular;
    // evita sobrescribir el precio principal con "$ 0,00" (inputs undefined -> NaN)
     if (!document.querySelector('#current_variant_price')) return;
  
     var value = $('.tab.active').attr('value');
     var subscription_discount = $("#subscription_discount").val();

    original_price = $("#current_variant_price").val();
    base_product_price = $("#base_product_price").val();
    suscription_price= base_product_price - (base_product_price * subscription_discount / 100);

    var selected_value =value;
    var price_ppr_ot = formatCurrency(original_price);
    var price_ppr_sus = formatCurrency(suscription_price);  
  
    if (selected_value == "one-time") {
      //$("#subscription-price").val("1");
      //$("#subscription-discount").val("");

    try{
      
      if(document.querySelector('.t4s-product__price-review .t4s-product-price ins')){
                
        $(".t4s-main-area .t4s-product__price-review .t4s-product-price ins").html(price_ppr_ot);        
        
        
      } else {
                   
        $(".t4s-main-area .t4s-product__price-review .t4s-product-price").html(price_ppr_ot);

      }
   
      
    }catch(e){}

    } else {
      
    try{

      //console.log("mirame", suscription_price)
      //$("#subscription-price").val(suscription_price);
      //$("#subscription-discount").val(subscription_discount);
      
      if(document.querySelector('.t4s-product__price-review .t4s-product-price ins')){
        
        $(".t4s-main-area .t4s-product__price-review .t4s-product-price ins").html(price_ppr_sus);
    
      } else {
                  
        $(".t4s-main-area .t4s-product__price-review .t4s-product-price").html(price_ppr_sus);        

      }   
    }catch(e){}
      
    }
      
    // NO actualizar los precios del componente aquí porque:
    // 1. Los precios del componente se actualizan cuando cambia la variante (en subs-component.liquid)
    // 2. Solo actualizar el precio principal del producto
    // 3. Si actualizamos aquí, podemos sobrescribir los cambios hechos por handleVariantChange()
    
    // Comentado para evitar conflictos:
    // if (selected_value == "one-time") {
    //   $("#compraUnica .mox-subs-price-container span ins").html(price_ppr_ot);
    // } else {
    //   if ($("#compraSubs").hasClass("active")) {
    //     $("#compraSubs .mox-subs-price-container div ins").html(price_ppr_sus);
    //   }
    // }  
    $("#purchaseTypeToggle_Value").val(selected_value);
  }


function formatCurrency(value) {
  // Convertir el valor a número, en caso de que sea una cadena
  let number = parseInt(value, 10);
  
  // Comprobar si el valor es un número válido
  if (isNaN(number)) {
    return "$ 0,00"; // Valor predeterminado en caso de error
  }

  // Dividir el número en miles y centavos
  let integerPart = Math.floor(number / 100);
  let decimalPart = number % 100;

  // Formatear las partes enteras con comas
  let formattedInteger = integerPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Formatear los centavos con dos dígitos
  let formattedDecimal = decimalPart < 10 ? `0${decimalPart}` : decimalPart;

  // Devolver el resultado formateado
  return `$ ${formattedInteger},${formattedDecimal}`;
}



// Inicializa los botones de suscripción de las tarjetas de producto.
// Sustituye al <script> inline que se emitía por cada tarjeta en product-grid-item-subs.liquid.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mox-subs-data').forEach(function (el) {
    var btn = document.querySelector('.t4s-pr-' + el.dataset.pid + ' .mox-subscription-button');
    if (!btn) return;
    var sel = document.getElementById('delivery-options-' + el.dataset.vid);
    var price = Number(el.dataset.price);
    var dcto = Number(el.dataset.dcto);
    btn.setAttribute('data-variant-subscription_freq', sel ? sel.value : '');
    btn.setAttribute('data-variant-subscription_price', price - (price * dcto / 100));
  });
});
